import { useState } from 'react';
import {
  FormData,
  COMPONENT_TYPE_GUEST,
  Guests,
  mapGuestsToSubmissionData,
  FormSubmissionData,
  useSubmitForm,
  extractRadiobuttonsAndCheckboxes,
} from '@entities/leadCollector';
import type { SubmitFormResponse } from '@entities/leadCollector';

export const useFormSubmission = (hash: string | undefined, formData: FormData | undefined) => {
  const { submitForm } = useSubmitForm();
  const [submissionResponse, setSubmissionResponse] = useState<SubmitFormResponse['submitForm'] | null>(null);

  const collectFormData = (): FormSubmissionData | null => {
    if (!formData) return null;

    const guestComponent = formData.components.find((component) => component.type === COMPONENT_TYPE_GUEST);
    if (!guestComponent) return null;

    const guests = guestComponent.properties as unknown as Guests;
    const submissionData = mapGuestsToSubmissionData(guests);

    const { radiobuttons, checkboxes } = extractRadiobuttonsAndCheckboxes(formData);

    return {
      ...submissionData,
      ...(radiobuttons && { radiobuttons }),
      ...(checkboxes && { checkboxes }),
    };
  };

  const handleSubmitForm = async () => {
    if (!hash) return;

    const submissionData = collectFormData();
    if (!submissionData) return;

    const submissionInfo = JSON.stringify(submissionData);
    const result = await submitForm({
      formLink: hash,
      submissionInfo,
    });

    if (result.data?.submitForm) {
      setSubmissionResponse(result.data.submitForm);
    }
  };

  return { submissionResponse, handleSubmitForm };
};
